export default class rs {
  constructor(t) {
    (this.productId = t), (this.productId = t);
  }
  Bl(t) {
    return null == this.productId || t[0] === this.productId;
  }
  static fromJson(t) {
    return new rs(t ? t.product_id : null);
  }
  tt() {
    return this.productId;
  }
}
